function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import styled, { css } from '../../_snowpack/pkg/styled-components.js';
const Outer = styled.div.withConfig({
  displayName: "card__Outer",
  componentId: "sc-1bi212a-0"
})(["position:relative;min-width:100%;"]);
export const visualStylesCard = css(["background:#fff;box-shadow:0px 2px 4px rgba(211,207,244,0.2);border-radius:", "px;"], p => p.borderRadius ? p.borderRadius : '0');
const Inner = styled.div.withConfig({
  displayName: "card__Inner",
  componentId: "sc-1bi212a-1"
})(["padding-bottom:5px;padding-top:5px;height:100%;", ""], visualStylesCard);
export function Card(props) {
  const {
    className,
    children,
    borderRadius = 0,
    zIndexBase = 0,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Outer, _extends({
    className: `card ${className}`
  }, rest), /*#__PURE__*/React.createElement(Inner, {
    className: "card__inner",
    borderRadius: borderRadius,
    zIndexBase: zIndexBase
  }, children));
}